export default __webpack_public_path__ + "static/media/dashboard-icon.e22df28c.svg";